// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/tsb-definitions.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/tsb-definitions/tsb-definitions.js';

mount([g0]);
